import { Button } from '../ui/button';
import { RefreshCw, Download, Plus } from 'lucide-react';
import { TYPE, SPACING, CONTROLS } from '../../lib/design-tokens';

/**
 * PageToolbar — Sticky toolbar bovenaan elke pagina
 *
 * STANDAARD: H1 = 24px/semibold, knoppen = 40px, padding = 24px
 */
export const PageToolbar = ({
  title,
  subtitle,
  count,
  onRefresh,
  onExport,
  onAdd,
  addLabel = 'Toevoegen',
  children,
  testId = 'page',
}) => (
  <div className="sticky top-0 z-20 bg-white border-b border-neutral-200" data-testid={`${testId}-toolbar`}>
    <div className={`${SPACING.pagePx} ${SPACING.pagePy} flex items-center justify-between gap-4`}>
      <div className="flex items-center gap-3">
        <div>
          <div className="flex items-center gap-3">
            <h1 className={TYPE.h1} data-testid={`${testId}-title`}>{title}</h1>
            {count !== undefined && count !== null && (
              <span className={TYPE.countBadge}>{count}</span>
            )}
          </div>
          {subtitle && <p className={`${TYPE.subtitle} ${SPACING.titleToSub}`}>{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center gap-2">
        {onRefresh && (
          <Button variant="outline" className={`${CONTROLS.primary} border-neutral-200 text-neutral-600`} onClick={onRefresh} data-testid={`${testId}-refresh`}>
            <RefreshCw className="h-4 w-4 mr-1.5" strokeWidth={1.5} />Ververs
          </Button>
        )}
        {onExport && (
          <Button variant="outline" className={`${CONTROLS.primary} border-neutral-200 text-neutral-600`} onClick={onExport} data-testid={`${testId}-export`}>
            <Download className="h-4 w-4 mr-1.5" strokeWidth={1.5} />Export
          </Button>
        )}
        {children}
        {onAdd && (
          <Button className={`${CONTROLS.primary} bg-[#111827] text-white hover:bg-neutral-800`} onClick={onAdd} data-testid={`${testId}-add`}>
            <Plus className="h-4 w-4 mr-1.5" strokeWidth={2} />{addLabel}
          </Button>
        )}
      </div>
    </div>
  </div>
);
